import { RuleValidation } from '../../CampaignModalSkeleton/CampaignModalSkeleton.types'
import { BogoDiffRuleState } from './types'

export function validateBogoDiffRule(rule: BogoDiffRuleState): RuleValidation {
	const ok = rule.selectedProducts.some((p) => p.productKey && p.productOfferedKey)
	if (!ok) {
		return { isValid: false, errors: { products: 'empty' } }
	}
	return { isValid: true, errors: {} }
}
